import i18n from '@flowus/common/i18n';

/** 图例位置 */
export type LegendAlignPosition = 'top' | 'bottom' | 'left' | 'right' | 'none';

export const LegendAlignPositionData: Record<LegendAlignPosition, string> = {
  top: i18n.t('editor.component.chart.chart_config_panel.style.const.top_position'),
  bottom: i18n.t('editor.component.chart.chart_config_panel.style.const.bottom_position'),
  left: i18n.t('editor.component.chart.chart_config_panel.style.const.left_position'),
  right: i18n.t('editor.component.chart.chart_config_panel.style.const.right_position'),
  none: i18n.t('common.no_display'),
};
